import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_ENVIRONMENT

  // Don't send events from local dev unless a DSN is explicitly provided.
  if (!dsn) return

  Sentry.init({
    dsn,
    environment,
    // __APP_VERSION__ is injected by vite.config.ts (VITE_BUILD_VERSION or a timestamp).
    release: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : undefined,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],

    // Performance tracing
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
    // Do NOT attach `sentry-trace`/`baggage` headers to any outgoing request.
    // The backend CORS config doesn't allow those headers, so propagating them
    // breaks API/auth (Clerk) calls. Re-enable with the backend's API URL only
    // once the backend is Sentry-instrumented AND its CORS allowedHeaders
    // include 'sentry-trace' and 'baggage'.
    tracePropagationTargets: [],

    // Session Replay
    replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE ?? 0),
    replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE ?? 1),

    enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  })
}
